import { render, staticRenderFns } from "./WowStreamerInfo.vue?vue&type=template&id=0d16bc89&scoped=true"
import script from "./WowStreamerInfo.vue?vue&type=script&lang=js"
export * from "./WowStreamerInfo.vue?vue&type=script&lang=js"
import style0 from "./WowStreamerInfo.vue?vue&type=style&index=0&id=0d16bc89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16bc89",
  null
  
)

export default component.exports